module.exports = __webpack_public_path__ + "static/media/datasheet_listData_row3_certificate.c1106b99.png";